import { shallowRef, computed, unref } from "vue";
import { u as unwrapEl } from "../utils/unwrapEl-4d79d250.mjs";
const unrefElement = (el) => {
  const e = unref(el);
  return unwrapEl(e);
};
const useElementRef = () => {
  const el = shallowRef();
  return computed({
    get() {
      return unrefElement(el);
    },
    set(node) {
      el.value = node;
    }
  });
};
export {
  useElementRef as u
};
//# sourceMappingURL=useElementRef-9cfaf4d1.mjs.map
